export default __webpack_public_path__ + "guide-access-elevation-data-example-response-960-26ea51a557c546eb5944e864473a97ae.webp";